import { Component, OnInit, EventEmitter, ViewChild, Output, ViewContainerRef, TemplateRef, Input } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';


// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

// ag- table component

import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';




import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter, PageService, PdfExportService, SortService } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { MysqlService } from './../../../services/mysql.service';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

import {Brand} from './../../../shared/models/brand.model';
import { Job } from '../../../shared/models/job.model';
import { JobSubject } from '../../../shared/models/jobSubject.model';
import { SearchSubject } from '../../../shared/models/searchSubject.model';
import {SearchContact} from '../../../shared/models/searchContact.model';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { BsModalService } from 'ngx-bootstrap/modal';

import {SearchPayment} from '../../../shared/models/searchPayments.model';
import { environment } from './../../../../environments/environment';
import { MyobApiInvoiceSyncToolsWidgetComponent } from 'src/app/components/myob/myob-api-invoice-sync-tools-widget/myob-api-invoice-sync-tools-widget.component';
import { ClientInvoiceBulkPaymentWidgetComponent } from 'src/app/components/invoices/client-invoice-bulk-payment-widget/client-invoice-bulk-payment-widget.component';


@Component({
  selector: 'app-client-outstandings',
  templateUrl: './client-outstandings.component.html',
  styleUrls: ['./client-outstandings.component.css']
})

export class ClientOutstandingsComponent implements OnInit {

  SERVICE_URI = environment.apiURL + ' /api/job/table/all';

sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  valueDatePickerDate: any;
  search_model: SearchPayment;

  initialPage: { pageSize: number; };
  @Input() brand_id?; 

  @ViewChild('grid') grid: GridComponent;
  // TABS sets the selected
  @ViewChild('staticTabs') staticTabs: TabsetComponent;
  brand_types: any;
  users: any;
  usersPrimary: any;
  contact_search: any;
  contact_search_results: any;
  brand_user_join_results: any[];
  brand_search: any;
  brand_search_results: any;
  brand_user_join_results_agent: any[];
  brand_search_results_agent: any;
  join_results: any[];
  user_levels: any;
  user_search: any;
  user_search_results: any;
  search_results: any;

  invoices: any;
  payments: any;

   // Grid Vars
   public data: DataManager;
   public data_subjects: DataManager;
   public pageSettings: Object;
   public pageOptions = { pageSize: 100 }; 
   public filterOptions: FilterSettingsModel;
   public formatOptions: Object;
   // public filterOptions: FilterSettingsModel;
   public filter : IFilter;
   public toolbarOptions: ToolbarItems[];
   public groupOptions: GroupSettingsModel;
   public templateOptionsDate: IFilterUI;
   public elem1: HTMLElement;
   public datePickerObj: DatePicker;
   subjects_urgent: any;
   formatoptions: { type: string; format: string; };
   dateFormat: string;
   sortOptions: { columns: { field: string; direction: string; }[]; };
   
  //  today = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
   today = new Date();
  modalRef: any;
  payments_search: Object;
  payments_search_results: any;
  total_invoices_paid: any;
  total_invoices_paid_amount: number;
  total_invoices_to_pay: number;
  total_invoices_to_pay_amount: number;
  total_invoices_already_paid: number;
  total_invoices_already_amount: number;
  total_invoices_not_yet_generated: number;
  brands_agent: any;
   // today_set = new Date(); // sets todays date
   // today = this.datepipe.transform(this.today_set, 'dd/MM/yyyy h:mm a'); // formats date for comparison

   public brand_fields: Object = { text: 'NameAndAddress', value: 'brand_id' }; // using the name field not id!
   client_fields: Object = { text: 'user_full_name', value: 'user_id' };
  invoices_to_pay_array: any;
  brands_client: any;
  invoice_status_all: any;
  invoice_payment_status_all: any;
  invoice_communication_status_all: any;
  @Input() widget_size?;

  

  constructor(
    private http: HttpClient, private router: Router, route: ActivatedRoute,private _demoService: DemoService,
    public datepipe: DatePipe,
    public toastr: HotToastService,
    private _mysqlService: MysqlService, 
    public gfunc: GlobalFunctionsService,
    private modalService: BsModalService,
    vcr: ViewContainerRef,
    public myob_sync_tools: MyobApiInvoiceSyncToolsWidgetComponent, // this is the way! - links to sync inclued component where all my masters will reside. in One place
    public cIBP: ClientInvoiceBulkPaymentWidgetComponent
  ) { 

    
       // Set and Access login Session Variables
       this.gfunc.setLoginSessionVars(); // set in a global function file
       this.sessionUserId = this.gfunc.currentUserVAR.user_id;
       this.sessionUsername = this.gfunc.currentUserVAR.username;
       this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
      
            // need to add this as routes does not work globally
            this.all_router_details = this.router.url;
            this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
      
         //   this.toastr.setRootViewContainerRef(vcr);
      // Date picker date format
       //  this.valueDatePickerDate = new Date(this.today);

       this.getInvoiceStatusAll();
this.getInvoicePaymentStatusAll();
this.getInvoiceCommunicationStatusAll();
   
  }


  ngOnInit() {

    // this.getPayments();



    this.search_model = new SearchPayment();
    this.search_model.invoice_payment_status_id = 1; // outstanding
this.search_model.invoice_status_id = 3; // approved

this.search_model.to_brand_id = this.brand_id;

    // this.getFormUserLevels();
    // this.getBrandBrandTypes();

    // this.mapJobTableLive(); // load the table data
    // this.mapJobTableLiveClients();
    // this.mapJobTableLiveAgents();
    
    this.toolbarOptions = ['ExcelExport', 'Search', 'PdfExport'];
    this.initialPage = { pageSize:5 };
    this.filterOptions = {
      type: 'Menu'
   };
  // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
   this.formatOptions= {type:'date', format:'dd/MM/yyyy' };
   this.dateFormat = 'dd/MM/yyyy hh:mm a';
  //  this.dateFormat = 'dd/MM/yyyy';
   this.filter = { params: { format: this.dateFormat } };
  this.pageOptions = { pageSize: 100 }; 



  this.getBrandsComboBoxClients(this.search_model);


  }




ngOnChanges(){

  this.search_model = new SearchPayment();
  // this.search_model.invoice_payment_status_id = 1; // outstanding
// this.search_model.invoice_status_id = 3; // approved

this.search_model.to_brand_id = this.brand_id;

  // this.getFormUserLevels();
  // this.getBrandBrandTypes();

  // this.mapJobTableLive(); // load the table data
  // this.mapJobTableLiveClients();
  // this.mapJobTableLiveAgents();
  
  this.toolbarOptions = ['ExcelExport', 'Search', 'PdfExport'];
  this.initialPage = { pageSize:5 };
  this.filterOptions = {
    type: 'Menu'
 };
// this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
 this.formatOptions= {type:'date', format:'dd/MM/yyyy' };
 this.dateFormat = 'dd/MM/yyyy hh:mm a';
//  this.dateFormat = 'dd/MM/yyyy';
 this.filter = { params: { format: this.dateFormat } };
this.pageOptions = { pageSize: 100 }; 



this.getBrandsComboBoxClients(this.search_model);


this.getInvoicesSearch(this.search_model)

}









  toolbarClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
        this.grid.excelExport();
    }
  }
  rowDataBound(args: RowDataBoundEventArgs) {
    // const job_status = 'job_status';
    // if (args.data[job_status] === 'CLOSED') {
    //     args.row.className = 'strikethrough';
    // }
  }
  
  refreshGrid(){ // refresh the databutton
 
    this.grid.refresh();
  };
  
  
  
  
  getBrandBrandTypes(){
    this._demoService.getBrandBrandTypes().subscribe(
      data => { this.brand_types = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }
  
  getUsers() {
    this._demoService.getUsers().subscribe(
      data => { this.users = data;
        this.usersPrimary = data;
       let res = data[0];
     },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }
  
  
  brandView(brand_id) {
    this.router.navigate(['/admin/brands/company/view/' + brand_id + '']);
  }
  
  brandEdit(brand_id) {
    this.router.navigate(['/admin/brands/company/edit/' + brand_id + '']);
  }
  
  
  userView(user_id) {
    this.router.navigate(['/admin/brands/users/view/' + user_id + '']);
  }
  
  userEdit(user_id) {
    this.router.navigate(['/admin/brands/users/edit/' + user_id + '']);
  }
  
  
  
  
  // :: Reporting
  getReportContactsSearch(search_model) {
   


    search_model.brand_type_id = null;
    search_model.assigned_agent = null;
    this._demoService.getReportContactsSearch(search_model).subscribe(
      data => { this.contact_search = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.contact_search_results = DataUtil.parse.parseJson(data); 
     //   this.subjects_results = DataUtil.parse.parseJson(data); 
       // console.log("Done loadng USER");
      //  console.log(data);
  
     //  this.items = new DataManager(data as JSON[]).executeLocal(new Query().take(1000));
       this.grid.refresh();
     
       // :: This section allow to hard code predicate filters before loading data in to DataManager
  
        // let predicate: Predicate = new Predicate('subject_name', 'equal', 'Mr Josh Mosh');
        // predicate = predicate.or('subject_id', 'equal', 303);
        // this.items =  new DataManager(this.subjects_urgent).executeLocal(new Query().where(predicate).take(8));
  
      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      //return Observable.throw(error);
      }
    ); }
  
  
  
    
  // :: Reporting
  getReportBrandsClientSearch(search_model) {
  this.brand_user_join_results = [];
  search_model.brand_type_id = 2;
  search_model.access_level = 9;
  
  
    // search_model.brand_report_id = null;
    // search_model.assigned_agent = null;
    this._demoService.getReportBrandsSearch(search_model).subscribe(
      data => { this.brand_search = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.brand_search_results = DataUtil.parse.parseJson(data); 
  // get the users as well and join the records together
  this.getReportUsersSearch(search_model);
  
  // now how to join two arrays of objects.
  // maybe pass results in to a new model.
  
  // Count items of brand search to loop through
  let  count_of_brand_items = Object.keys(this.brand_search).length;
  // now loop and push to join model
  for(let i=0;i < count_of_brand_items; i++) {
    let res = this.brand_search[i];
  
      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
      this.brand_user_join_results.push({
        email_address: res.email,
        first_name: res.name,
        surname: res.surname,
        company_name: res.name,
        created: res.created,
              });
  
  } // end brands loop.
  
  
  
  
  
  
  this.brand_user_join_results = this.brand_user_join_results;



  
       this.grid.refresh();
      },
      error => {
      console.error('Error Loading !' + error.error);
      console.log(error);
      // return Observable.throw(error);
      }
  
  
  
      
    ); }
  
  
  
    
  
    getReportBrandsAgentSearch(search_model) {
      this.brand_user_join_results = [];
      search_model.brand_type_id = 3;
      search_model.access_level = 5;
      this._demoService.getReportBrandsSearch(search_model).subscribe(
        data => { this.brand_search = data;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.brand_search_results = DataUtil.parse.parseJson(data); 
    // get the users as well and join the records together
    this.getReportUsersSearch(search_model);
    
    // now how to join two arrays of objects.
    // maybe pass results in to a new model.
    
    // Count items of brand search to loop through
    let  count_of_brand_items = Object.keys(this.brand_search).length;
    // now loop and push to join model
    for(let i=0;i < count_of_brand_items; i++) {
      let res = this.brand_search_results[i];
    
        // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
        this.brand_user_join_results.push({
          email_address: res.email,
          first_name: res.name,
          surname: res.surname,
          company_name: res.name,
          created: res.created,
                });
    
    } // end brands loop.
    
    this.brand_user_join_results = this.brand_user_join_results;
    
         this.grid.refresh();
      
          },
          error => {
          console.error('Error Loading !' + error.error);
          console.log(error);
          // return Observable.throw(error);
          }
          );
           
  
            }
      
  
  
  
    getFormUserLevels() {
      this._demoService.getFormUserLevels().subscribe(
         data2 => { this.user_levels = data2;
          console.log(data2);
       },
         err => console.error(err),
         () => console.log('done loading User Levels')
       );
     }
  
  
     getBrandTypes() {
      this._demoService.getBrandBrandTypes().subscribe(
         data => { this.brand_types = data; },
         err => console.error(err),
         // () => console.log('done loading candidate for update')
       );
     }
    
  
    getReportUsersSearch(search_model) {
  
      this._demoService.getReportUsersSearch(search_model).subscribe(
        data => { this.user_search = data;
          // pass so that the dates are correct in Sync
          // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
          this.user_search_results = DataUtil.parse.parseJson(data);
  // Count items of users search to loop through
  let  count_of_user_items = Object.keys(this.user_search).length;
  // now loop and push to join model
  for(let i=0;i < count_of_user_items; i++) {
    let res = this.user_search_results[i];
  
  
      // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
      this.brand_user_join_results.push({
        email_address: res.email_address,
        first_name: res.first_name,
        surname: res.surname,
        company_name: res.company_name,
        created_date: res.created_date,
              });
  
  
  } // end users loop.
  
  this.brand_user_join_results =  this.brand_user_join_results;
  this.grid.refresh();
       //  this.agent_grid.refresh();
        },
        error => {
        console.error('Error Loading !' + error.error);
        console.log(error);
        // return Observable.throw(error);
        }
      ); }
  
  
  
  addDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + days);
  return futureDate;
  }
  
  
  removeDays(days : number): Date{
  let futureDate = new Date();
  futureDate.setDate(futureDate.getDate() - days);
  return futureDate;
  }
  
  /// TABS
  selectTab(tab_id: number) {
  this.staticTabs.tabs[tab_id].active = true;
  this.join_results = null; // refresh the model when a tab is clicked.?
  };
  
  
  
  
  
  
  
  
    // https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
    clickHandler(args: ClickEventArgs): void {
      if (args.item.id === 'Click') {
  
      //  this.grid.showSpinner();
  
      //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
     //  console.log(args.data.items);
     
  
  
      let pdfdata;
      const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
      for (let i = 0; i < query.queries.length; i++) {
        if (query.queries[i].fn === 'onPage') {
          query.queries.splice(i, 1);       // remove page query to get all records
          break;
        }
      }
      const fdata = new DataManager({ json: this.brand_user_join_results }).executeQuery(query).then((e: any) => {
        pdfdata = e.result as object[];  // get all filtered records
        const exportProperties = {
          dataSource: pdfdata,
        };
        //console.log(pdfdata.results);
        
       // this.search_results = pdfdata.records; // need this if a grouping is set.
        this.search_results = pdfdata;
        this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
        this.toastr.success( "Press Start To Process Que"); 
       // this.grid.pdfExport(exportProperties);
      }).catch((e) => true);
      }
  
     //  this.grid.hideSpinner();
  
  }
  
  
  exportPDFClick(args: ClickEventArgs): void {
    if (args.item.id === 'Grid_pdfexport') { // 'Grid_pdfexport' -> Grid component id + _ + toolbar item name
        this.grid.pdfExport();
    }
  }




  getPayments() {
    this._demoService.getPayments().subscribe(
       data => { this.payments = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   } 
  
  getInvoices() {
    this._demoService.getInvoices().subscribe(
       data => { this.invoices = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



   // MODAL
  // start of modal windows service as a template
  openModal(template: TemplateRef<any>) {
    // small upgrade to disable background click on open modal background
    const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
    this.modalRef = this.modalService.show(template, config);
  }
  
  // :: Parent / Child modal test
  closeParentModel() {
    // alert('parent component function.');
    this.modalRef.hide();
   // this.refreshGrid(); // resets the grid if updated and closed.
  //  this.updateTypeClick = false; // closes the div
  };
  








  getInvoicesSearch(search_model) {
    this.join_results = [];
    search_model.brand_type_id = 0;
    search_model.access_level = 0;
    this._demoService.getInvoicesSearch(search_model).subscribe(
      data => { this.payments_search = data;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        this.payments_search_results = DataUtil.parse.parseJson(data);


        // get the users as well and join the records together
        //  this.getReportUsersSearch(search_model);

  // now how to join two arrays of objects.
  // maybe pass results in to a new model.

              // Count items of brand search to loop through
              let  count_of_payment_items = Object.keys(this.payments_search).length;
              // now loop and push to join model
              for(let i=0;i < count_of_payment_items; i++) {
                let res = this.payments_search_results[i];

               let current_invoice_id = this.payments_search_results[i].invoice_id;
               if(current_invoice_id == null) {
                // this.payments_search_results[i].to_brand_name = 'NO_SUPPLIER_INVOICE_';
               }

                  // push to holding list of invoice items, all current subject_billing_items. (no filtering as yet.)
                  this.join_results.push({
                   ...this.payments_search_results[i]
                          });

              } // end brands loop.


              // this.join_results = this.join_results;

              this.grid.refresh();

// Works well
        // let filtered_results =   this.join_results.filter(function(responseData) {
        //   return responseData.invoice_id !== null;
        // });
        //  this.join_results = filtered_results;

// Payments need to be
// invoice_status = approved
// invoice_payment_status != PAID


// Calculate some numbers
          this.total_invoices_paid = this.join_results.length;
          this.total_invoices_paid_amount = this.join_results.filter((item) => item.invoice_total)
          .map((item) => +item.invoice_total)
          .reduce((sum, current) => sum + current);
          this.total_invoices_to_pay = this.join_results.filter((item) => item.invoice_id && item.invoice_payment_status_id !== '2')
          .map((item) => +item.invoice_id).length;
          // tslint:disable-next-line:max-line-length
          this.total_invoices_to_pay_amount = this.join_results.filter((item) => item.invoice_total && item.invoice_payment_status_id !== '2')
          .map((item) => +item.invoice_total)
          .reduce((sum, current) => sum + current);
          this.total_invoices_already_paid = this.join_results.filter((item) => item.invoice_id && item.invoice_payment_status_id === '2')
          .map((item) => +item.invoice_id).length;
          // tslint:disable-next-line:max-line-length
          this.total_invoices_already_amount = this.join_results.filter((item) => item.invoice_total && item.invoice_payment_status_id === '2')
          .map((item) => +item.invoice_total)
          .reduce((sum, current) => sum + current);
          this.total_invoices_not_yet_generated = this.join_results.filter((item) => item.invoice_id && item.invoice_id === null)
          .map((item) => +item.invoice_id).length;

          // this.invoices_to_pay_array = this.join_results.filter((item) => item.invoice_id && item.invoice_payment_status_id !== '2')
          // .map((item) => +item.invoice_id);
          // tslint:disable-next-line:max-line-length
          // let invoices_to_pay_array = Object(this.join_results).filter((item)=>(item.invoice_payment_status_id !== '2')); // User this if filter is needed.
          this.invoices_to_pay_array = this.join_results;


        },
        error => {
        console.log('Error Loading !' + error.error);
        // console.log(error);
        // return Observable.throw(error);
        }
        );
         

          }




          getBrandsComboBoxAgents(search_model) {
            this.search_model.brand_type_id = 3;
           this._demoService.getBrandsComboBox(search_model).subscribe(
              data => { this.brands_agent = data; },
              err => console.error(err),
              // () => console.log('done loading Trace Types')
            );
           }




           
getBrandsComboBoxClients(search_model) {
  this.search_model.brand_type_id = 2;
 this._demoService.getBrandsComboBox(search_model).subscribe(
    data => { this.brands_client = data; },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}



getInvoiceStatusAll(){
  this._demoService.getInvoiceStatusAll().subscribe(
    (data) => {
      this.invoice_status_all = data;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}

getInvoicePaymentStatusAll(){
  this._demoService.getInvoicePaymentStatusAll().subscribe(
    (data) => {
      this.invoice_payment_status_all = data;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}


getInvoiceCommunicationStatusAll(){
  this._demoService.getInvoiceCommunicationStatusAll().subscribe(
    (data) => {
      this.invoice_communication_status_all = data;
      let res = data[0];
    },
    (err) => console.error(err),
   // () => console.log('Brand Loaded.')
  );
}



}
